const ffToShowHideLine = (field) => ({
    state: field.state,
    hasError: field.error,
    domRef: field.domRef,
});
exports.ffToShowHideLine = ffToShowHideLine;
